import { useMemo } from 'react';
import StarterKit from '@tiptap/starter-kit';
import TextStyle from '@tiptap/extension-text-style';
import Link from '@tiptap/extension-link';
import BubbleMenu from '@tiptap/extension-bubble-menu';
import FloatingMenu from '@tiptap/extension-floating-menu';
import TextAlign from '@tiptap/extension-text-align';
import Underline from '@tiptap/extension-underline';
import Image from "./Image.js";
import Extensions from "./Extensions.js";
function useExtensions(opts) {
  return useMemo(() => {
    const extensions = Extensions.configureAll(opts);
    return [StarterKit, TextStyle, Link, Image.configure({
      inline: true,
      allowBase64: true
    }), BubbleMenu, FloatingMenu, TextAlign.configure({
      types: ['heading', 'paragraph']
    }), Underline, ...extensions];
  }, [opts]);
}
export default useExtensions;